




import React from "react";
import { Link } from "react-router-dom";
import "../styles/Cargoes.css";

// Import your icon and image
import cargoesIcon from "../assets/icons/cargo-icon.png";
import cargoesImage from "../image/Cargoes-image.png";

const Cargoes = () => {
  return (
    <div className="cargo-container">
      {/* Image Slider */}
      <div className="cargo-image-slider">
        <img src={cargoesImage} alt="Cargoes Slider" />
      </div>

      {/* Main Content Container */}
      <div className="cargo-content">
        {/* Content Card with title inside */}
        <div className="cargo-card">
          {/* Ship wheel icon and title */}
          <div className="cargo-header-container">
            <img src={cargoesIcon} alt="Cargoes" className="cargo-wheel-icon" />
            <div className="cargo-header-title">Cargoes</div>
          </div>
          
          {/* Content */}
          <div className="cargo-text-content">
            <h3 className="cargo-subtitle">Break bulk cargoes :</h3>
            <p className="cargo-text">
              Break bulk cargoes are classified as cargoes which are packed in cases, bales, cartons, drums etc., and these cargo are carried in the ship's cargo holds rather than in containers.
            </p>
            
            <p className="cargo-text">
              Under this category ECL specialises in carrying Steel Coils, Steel Plates, Granite Blocks, Bagged Products, Crated & Palletized cargoes, Forest Products, Rolling Stocks, Vehicles, Earth Moving Equipments and other Self Driven Equipments also form part of the break-bulk cargoes.
            </p>
            
            <p className="cargo-text">
              Under Project Cargoes, ECL specialises in carrying Turbines, Plant & Machinery, Boilers, Locomotives, Boats, Press Machines, Castings Reels, Wind Mill Blades/Towers, and Offshore Equipments.
            </p>
            
            <h3 className="cargo-subtitle">Dry bulk cargoes :</h3>
            <p className="cargo-text">
              Dry Bulk cargo is defined as cargo that is unpacked and is of the same or a similar kind or homogeneous in nature. These cargoes are usually loaded / discharged with a spout, shovel bucket or by grabs into/from the vessels holds.
            </p>
            
            <p className="cargo-text">
              Under this category ECL specialises in carrying cargoes such as Ferro Chrome, Chrome Ore, Chrome Concentrate, Manganese Ore, Zinc Concentrate, Lead Concentrates, Ilmenite Sand and Agri Products such as Rape Seed Meal and Soya Bean Meal.
            </p>
            
            <h3 className="cargo-subtitle">Automobiles :</h3>
            <p className="cargo-text">
              ECL services the Indian automobile industry in transporting Completely Built Units (CBUs) which includes Passenger Cars, Buses, Trucks, Off-Highway Vehicles and other Commercial Equipments.
            </p>
          </div>
          
          {/* Right Side Panel */}
          <div className="cargo-side-panel">
            <Link to="/map" className="cargo-panel-link">
              <div className="cargo-panel-section">
                <h4 className="cargo-panel-title">Map :</h4>
                <p className="cargo-panel-text">
                  Get the Map & Routes
                </p>
              </div>
            </Link>
            
            <Link to="/inland-logistics" className="cargo-panel-link">
              <div className="cargo-panel-section">
                <h4 className="cargo-panel-title">Inland Logistics :</h4>
                <p className="cargo-panel-text">
                  Concurrent with their Liner service, ECL Shipping offers Inland Logistics solutions as a value added service to complement their ocean transportation service.
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cargoes;